export const safeMatchRegexp = (
  regExpString: string,
  value: string,
): RegExpMatchArray | null => {
  try {
    return value.match(new RegExp(regExpString));
  } catch {
    return null;
  }
};
